import qs from 'qs';

export default function getSearchQuery(queryString) {
  return qs.parse(queryString, { ignoreQueryPrefix: true });
}
